/* Icones dos USPs na cor da loja (#942547), 60x60 como na referencia.

   Os icones originais da Lea sao PNG com fundo branco opaco (0% de pixeis
   transparentes), por isso nao podiam ser recoloridos por filtro nem por
   mascara. Sao substituidos por icones vectoriais desenhados aqui.

   Nota 1: as imagens do tema vem dentro de um <figure class="image-wrapper">
   com uma caixa de aspect-ratio propria. O icone novo entra como IRMAO desse
   figure (e o figure e escondido inteiro), senao transborda e fica por cima
   do titulo.

   Nota 2: o numero dentro do icone de devolucoes e um <text> do SVG, nao um
   desenho — desenhar digitos a mao dava leituras erradas. */
(function () {
  var ICONS = {
    shipping:
      '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/>' +
      '<circle cx="7.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    payment:
      '<rect x="2.5" y="6" width="19" height="13" rx="2"/><path d="M2.5 10h19"/>' +
      '<path d="M6 15h4"/>',
    returns:
      '<path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20.5 3.5V8H16"/>' +
      '<text x="12" y="15.4" text-anchor="middle" font-family="Outfit, sans-serif" ' +
      'font-size="8" font-weight="500" letter-spacing="0" fill="currentColor" ' +
      'stroke="none">30</text>',
    support:
      '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/>' +
      '<rect x="2.5" y="12.5" width="4" height="6" rx="1.6"/>' +
      '<rect x="17.5" y="12.5" width="4" height="6" rx="1.6"/>' +
      '<path d="M20 18.5v.5a3 3 0 0 1-3 3h-2.5"/>'
  };

  function pick(text) {
    var t = (text || '').toLowerCase();
    if (/livraison|expedition|expédition|shipping|gratuite/.test(t)) return 'shipping';
    if (/paiement|sécuris|securis|carte/.test(t)) return 'payment';
    if (/rembours|retour|30\s*jours|garantie/.test(t)) return 'returns';
    if (/support|service|client|24\/7|aide/.test(t)) return 'support';
    return 'shipping';
  }

  function svgFor(key) {
    return (
      '<svg class="sj-usp-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' +
      'width="60" height="60" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      ICONS[key] +
      '</svg>'
    );
  }

  function convert() {
    var scopes = document.querySelectorAll('.section-columns .column__inner, .multicolumn__item');
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      if (scope.dataset.sjUsp === '1') continue;

      var heading = scope.querySelector('.column__heading, h2, h3');
      if (!heading) continue;

      var media = scope.querySelector('img, svg');
      if (!media) continue;

      var target = media.closest('figure, .image-wrapper') || media;
      if (!target.parentNode) continue;

      scope.dataset.sjUsp = '1';

      var holder = document.createElement('span');
      holder.className = 'sj-usp-icon-holder';
      holder.innerHTML = svgFor(pick(heading.textContent));

      target.parentNode.insertBefore(holder, target);
      target.style.display = 'none';

      var stale = scope.querySelector('.sj-icon-mask');
      if (stale) stale.remove();
    }
  }

  function boot() {
    convert();
    var tries = 0;
    var timer = setInterval(function () {
      convert();
      if (++tries > 12) clearInterval(timer);
    }, 500);

    if (document.body) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(convert, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
